import { NgModule } from '@angular/core';
import { ProfileLinkProvider } from '@capital-access/profiles/common';
import { ProfilePreviewLinkComponent } from './profile-preview-link.component';

@NgModule({
  declarations: [ProfilePreviewLinkComponent],
  exports: [ProfilePreviewLinkComponent],
  providers: [ProfileLinkProvider]
})
export class ProfilePreviewLinkModule {}
